import { TITLE_OPTIONS } from '../FullName/types';
import { YesNoEnum } from '../HouseholdOutgoings/types';

export const previousNameQuestions: Record<string, any> = {
  title: {
    labelKey: 'applicationForm.PREVIOUS_NAME.titleAndFirstName.label',
    options: TITLE_OPTIONS.map(option => ({ label: option, value: option })),
  },
  firstName: {
    labelKey: 'applicationForm.PREVIOUS_NAME.titleAndFirstName.label',
    explanationKey: 'applicationForm.PREVIOUS_NAME.titleAndFirstName.explanation',
  },
  lastName: {
    labelKey: 'applicationForm.PREVIOUS_NAME.surname.label',
    explanationKey: 'applicationForm.PREVIOUS_NAME.surname.explanation',
  },
  isNameChanged: {
    labelKey: 'applicationForm.PREVIOUS_NAME.isNameChanged.label',
    options: [
      { labelKey: 'common.yes', value: YesNoEnum.YES },
      { labelKey: 'common.no', value: YesNoEnum.NO },
    ],
  },
};
